import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer>
      <p>&copy; 2024 Mont Capital Asset</p>
    </footer>
  );
};

export default Footer;